import * as React from "react";
import s from "./hero.scss";
import { smoothScrollTo } from "../../utils/smooth-scroll";
import Icon from "#components/icon";
import { heroContent } from "./content";
import { replacePlaceholders } from "../../utils/replace-placeholders";

interface HeroProps {
	year: number;
}

function handleClick(e: React.MouseEvent<HTMLAnchorElement>) {
	e.preventDefault();
	smoothScrollTo("operacao", 1000);
}

export function Hero({ year }: HeroProps) {
	return (
		<section id="hero" className={s.hero}>
			<div className={s.heroContent}>
				<h1 className={s.heroTitle}>
					{heroContent.title}
					<br />
					<span className={s.heroTitleHighlight}>{heroContent.titleHighlight}</span>
				</h1>
				<p className={s.heroSubtitle}>
					{replacePlaceholders(heroContent.subtitle, { year })}
				</p>
				<a href="#operacao" className={s.heroButton} onClick={handleClick}>
					<Icon icon="ri-rocket-2-line" />
					{heroContent.button}
				</a>
			</div>
		</section>
	);
}
